import { useState } from 'react'
import { Copy, Check } from 'lucide-react'
import { toast } from 'sonner'
import { cn } from '@/lib/utils'

interface CopyableCellProps {
  /** Valor a copiar al portapapeles */
  value: string
  /** Valor a mostrar (si difiere del valor a copiar) */
  displayValue?: string
  /** Clases CSS adicionales */
  className?: string
}

/**
 * Celda con funcionalidad click-to-copy
 * Muestra un icono de copiar en hover y feedback visual al copiar
 */
export function CopyableCell({ value, displayValue, className }: CopyableCellProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation()
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      toast.success('Copiado al portapapeles')
      setTimeout(() => setCopied(false), 2000)
    } catch {
      toast.error('Error al copiar')
    }
  }

  return (
    <button
      onClick={handleCopy}
      className={cn(
        'group flex items-center gap-1.5 text-left hover:text-primary transition-colors',
        className
      )}
      title="Click para copiar"
    >
      <span className="truncate">{displayValue || value}</span>
      {copied ? (
        <Check className="h-3.5 w-3.5 text-emerald-500 shrink-0" />
      ) : (
        <Copy className="h-3.5 w-3.5 opacity-0 group-hover:opacity-50 shrink-0 transition-opacity" />
      )}
    </button>
  )
}
